import React from "react";
import "./styles.css";

export default function Footer() {
  return (
    <small className="Footer" >
      <a
        href="https://github.com/Bancy614/weather-app-bancy-react"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>
      , by Bancy Ndirangu
    </small>
  );
}
   